"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ObservableCollection = void 0;
const lib_1 = require("../lib");
/**
 * Base class for an observable collection.
 */
class ObservableCollection {
    constructor() {
        this._ref = Symbol();
    }
    /**
     * Register a callback to be invoked each time this collection is mutated.
     */
    observe(callback, options) {
        lib_1.SubjectInstance.get(this).observe(callback, options);
    }
    /**
     * Unregister a callback.
     */
    unobserve(callback) {
        lib_1.SubjectInstance.get(this).unobserve(callback);
    }
    /**
     * Invoke from sub-classes to notify observers & update `ref`.
     *
     * @private
     */
    _changed() {
        lib_1.SubjectInstance.get(this).notify();
        this._ref = Symbol();
    }
    /**
     * An arbitrary value which changes each time this collection is mutated.
     *
     * Useful for integrating with reactive environments which use referential
     * equality to trigger updates, for example:
     *
     * ```js
     *    useEffect(() => { ... }, [ collection.ref ])
     * ```
     */
    get ref() {
        return this._ref;
    }
}
exports.ObservableCollection = ObservableCollection;
//# sourceMappingURL=observable-collection.js.map